import WeAreGoodIn from './WeAreGoodIn'

// importing helper components
import HeadingPart from '../../Helper/HeadingPart'
import MoreArrow from '../../Helper/MoreArrow'

// importing svg icons
import icon4 from '../../../assets/svg/Icon4.svg'
import icon5 from '../../../assets/svg/Icon5.svg'
import icon6 from '../../../assets/svg/Icon6.svg'
import icon7 from '../../../assets/svg/Icon7.svg'
import icon8 from '../../../assets/svg/Icon8.svg'
import icon9 from '../../../assets/svg/Icon9.svg'

// importing constants
import home from '../../../constants/home.js'
import moreArrow from '../../../constants/moreArrow.js'
import headingPart from '../../../constants/headingPart.js'

const index = () => {
  return (
    <div className="w-full">
        <div className="flex items-center md:justify-between">
            <HeadingPart heading={headingPart.HEADING_WE_ARE_GOOD_IN} text={headingPart.TEXT_WE_ARE_GOOD_IN} order_1={1} />
            <span className="hidden md:flex mr-8"><MoreArrow text={moreArrow.TEXT_REQUEST_CUSTOM_SERVICE} /></span>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 mt-8">
            <div className="md:border-r md:border-b md:w-11/12 xl:w-full xl:mb-0 xl:border-r xl:pb-12">
                <WeAreGoodIn icon={icon4} heading={home.WE_ARE_GOOD_IN_HEADING1} text={home.WE_ARE_GOOD_IN_TEXT1} />
            </div>

            <div className="md:border-b md:ml-[-2.5em] md:pb-5 md:w-11/12 md:pl-10 xl:border-r xl:w-full xl:mb-0 xl:ml-0 xl:pb-12 xl:pl-8">
                <WeAreGoodIn icon={icon5} heading={home.WE_ARE_GOOD_IN_HEADING2} text={home.WE_ARE_GOOD_IN_TEXT2} />
            </div>

            <div className="md:border-r md:border-b md:pb-5 md:pt-5 md:w-11/12 xl:w-full xl:mb-0 xl:pt-0 xl:border-r-0 xl:pb-12 xl:pl-8">
                <WeAreGoodIn icon={icon6} heading={home.WE_ARE_GOOD_IN_HEADING3} text={home.WE_ARE_GOOD_IN_TEXT3} />
            </div>

            <div className="md:border-b md:pt-5  md:pb-5 md:w-11/12 md:pl-10  md:ml-[-2.5em] xl:ml-0 xl:w-full xl:mb-0 xl:border-t xl:border-b-0 xl:pt-12 xl:pl-0 xl:border-r">
                <WeAreGoodIn icon={icon7} heading={home.WE_ARE_GOOD_IN_HEADING4} text={home.WE_ARE_GOOD_IN_TEXT4} />
            </div>

            <div className="md:border-r md:border-b-0 md:pt-5 md:mb-7 md:pb-5 md:w-11/12 xl:w-full xl:mb-0  xl:border-t xl:border-r xl:border-b-0 xl:pt-12 xl:pl-8">
                <WeAreGoodIn icon={icon8} heading={home.WE_ARE_GOOD_IN_HEADING5} text={home.WE_ARE_GOOD_IN_TEXT5} />
            </div>

            <div className="md:border-b-0 md:pt-5 md:mb-7 md:pb-5 md:w-11/12 md:pl-10  md:ml-[-2.5em] xl:ml-0 xl:w-full xl:mb-0 xl:border-b-0 xl:border-t xl:pt-12 xl:pl-8 xl:border-r-0">
                <WeAreGoodIn icon={icon9} heading={home.WE_ARE_GOOD_IN_HEADING6} text={home.WE_ARE_GOOD_IN_TEXT6} />
            </div>
        </div>
    </div>
  )
}

export default index